import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { EntreeJournal } from 'src/app/core/services/entities/journal.service';
import { JournalUtil } from './journal.util';

/** Ligne du journal : initiales, auteur · rôle, résumé, heure · action · module ; ouvre la fiche de l'élément */
@Component({
  selector: 'bay-entree-journal',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="bay-ej" [class.bay-ej-lien]="lien" [attr.role]="lien ? 'link' : null" [attr.tabindex]="lien ? 0 : null"
         (click)="ouvrir()" (keydown.enter)="ouvrir()" [attr.data-entree]="entree.id">
      <span class="bay-ej-avatar" aria-hidden="true">{{ initiales }}</span>
      <div class="bay-ej-corps">
        <div class="bay-ej-auteur">{{ entree.auteur?.nom || 'Système' }}<span *ngIf="entree.auteur?.role" class="bay-ej-role"> · {{ entree.auteur.role }}</span></div>
        <div class="bay-ej-resume">{{ entree.resume }}</div>
        <div class="bay-ej-meta">
          <span class="material-symbols-outlined" aria-hidden="true">{{ module.icone }}</span>
          {{ date | date:(avecJour ? 'dd/MM HH:mm' : 'HH:mm') }} · {{ action }} · {{ module.libelle }}
        </div>
      </div>
      <span *ngIf="lien" class="material-symbols-outlined bay-ej-chevron" aria-hidden="true">chevron_right</span>
    </div>
  `,
  styles: [`
    .bay-ej { display:flex; gap:12px; align-items:flex-start; padding:12px 8px; border-radius:12px; }
    .bay-ej-lien { cursor:pointer; }
    .bay-ej-lien:hover, .bay-ej-lien:focus-visible { background:#f3f7ee; outline:none; }
    .bay-ej-lien:focus-visible { box-shadow:0 0 0 3px #0d631b55; }
    .bay-ej-avatar { flex:0 0 36px; height:36px; border-radius:50%; background:#e5eadf; color:#0d631b; font-weight:700; font-size:13px;
      display:flex; align-items:center; justify-content:center; }
    .bay-ej-corps { flex:1; min-width:0; }
    .bay-ej-auteur { font-size:13px; font-weight:600; color:#111827; }
    .bay-ej-role { font-weight:400; color:#4b5563; }
    .bay-ej-resume { font-size:14px; color:#1f2937; margin:2px 0; }
    .bay-ej-meta { font-size:12px; color:#4b5563; display:flex; align-items:center; gap:4px; }
    .bay-ej-meta .material-symbols-outlined { font-size:15px; }
    .bay-ej-chevron { color:#9ca3af; align-self:center; }
  `]
})
export class EntreeJournalComponent implements OnChanges {
  @Input() entree!: EntreeJournal;
  /** Affiche aussi le jour (bloc « Activité récente », sans regroupement par jour) */
  @Input() avecJour = false;
  /** Sur la fiche de l'élément lui-même : pas de lien vers la page déjà ouverte */
  @Input() sansLien = false;

  initiales = '';
  date!: Date;
  action = '';
  module = JournalUtil.module(null);
  lien: any[] | null = null;

  constructor(private router: Router) {}

  ngOnChanges(): void {
    const e = this.entree;
    this.initiales = JournalUtil.initiales(e.auteur?.nom);
    this.date = JournalUtil.date(e.date);
    this.action = JournalUtil.libelleAction(e.action);
    this.module = JournalUtil.module(e.module);
    this.lien = this.sansLien ? null : JournalUtil.lien(e);
  }

  ouvrir(): void { if (this.lien) { this.router.navigate(this.lien); } }
}
